import fees from "../../images/highlights/fee.png";
import time from "../../images/highlights/time.png";


function FeatureSection() {

    return (
        <section className="section-colour">
            <div className="bottom-margin-1em">
                <h3>Fees and Availablity</h3>
                <div className="highlights">
                    <div className="feature">
                        <img src={fees} alt="search" />
                        <div>
                            <h5>Fees</h5>
                            <p>Individual sessions £90 - concession rates available</p>
                        </div>
                    </div>
                    <div className="feature">
                        <img src={time} alt="clock" />
                        <div>
                            <h5>Availablity</h5>
                            <p>I am available weekdays and in the evenings</p>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}

export default FeatureSection;